<div>
       <input id="{{datePickerId}}" type="text" class="form-control date-range-picker" ngxDaterangepickerMd 
              [ranges]="ranges"
              [locale]="{ format: 'MM/DD/YYYY' }" 
              [alwaysShowCalendars]="true" 
              [linkedCalendars]="true"
              [autoApply]="true"
              [minDate]="minDate"
              [maxDate]="maxDate"
              [drops]="dropPosition"
              [readonly]="customReadOnly"
              [(ngModel)]="selectedDate"
              (datesUpdated)="onDatesUpdate($event)"
              placeholder="MM/DD/YYYY">
       <!-- <i class="calendar-icon fa-regular fa-calendar"></i> Unicode for calendar icon -->
</div>